import styled from '@emotion/styled'
import { colors } from '../../../../__styling/settings/colors'
import { fonts } from '../../../../__styling/settings/fonts'
import { calcRem } from '../../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../../__styling/themed-value'

interface PositionState {
    alignToTop?: boolean
    isLowered?: boolean
}

export interface StyledUnmuteButtonProps {
    action?: () => void
    positionState?: PositionState
}

export const StyledUnmuteButton = styled('button')<StyledUnmuteButtonProps>(
    {
        backgroundColor: colors.black,
        color: colors.white,
        cursor: 'pointer',
        display: 'flex',
        border: `1px solid ${colors.white}`,
        borderRadius: calcRem(2),
        fontSize: calcRem(13),
        fontWeight: 'bold',
        padding: calcRem(7, 14),
        position: 'absolute',
        left: calcRem(16),
        bottom: calcRem(60),
        lineHeight: 1.6, // align SVG with text properly
        transition: 'transform 0.1s ease',
        top: 'auto',

        '&:hover': {
            backgroundColor: colors.white,
            borderColor: colors.black,
            color: colors.black,
        },

        '& svg': {
            marginRight: calcRem(8),
        },

        '&:hover svg g, &:hover svg path': {
            fill: colors.black,
        },

        '&.isLowered': {
            transform: `translateY(${calcRem(40)})`,
            transition: 'transform 1.0s ease',
        },

        '&.isCrushed': {
            bottom: 'auto',
            top: calcRem(20),
        },
    },
    ({ theme }) => ({
        fontFamily: themedValue(theme, {
            thewest: fonts.thewest.sansSerif,
            perthnow: fonts.perthnow.sansSerif,
            sevennews: fonts.sevennews.sansSerif,
        }),
    }),
)
